import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CContainer,
	CRow,CCol,
	CForm,CFormInput,CInputGroup,CInputGroupText,CFormSelect,
	CButton,
	CImage,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CSpinner,
	CLink,
	CDropdown,CDropdownItem,CDropdownToggle,CDropdownMenu,
	CTooltip,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { isMobile } from "react-device-detect";
import {
	MyDialogform,
	MyPagination,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc,cAngkaTgl,cBulanPendek,cBulanPanjang } from '../helpers/functions'

const pjson 		= require('../../package.json')
const Lapterapi	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 25) : (uSettingObj.jml_laporan || 100);
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uSystemsettingObj			= useSelector(state => state.gSystemsetting);
	
	const uHeaderActionObj  		= useSelector(state => state.gInitHeaderAction);
	const uHandelView 				= uHeaderActionObj.isHeaderView || false;
	const uHandelReset 				= uHeaderActionObj.isHeaderreset || false;

	//--VIEWS_VARS--/
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const uIsHapusallow					= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN") ? true : false;
	const [uIsDataloaded,setDataloaded]	= React.useState(false); 
	const [uCaptionObj,setCaptionObj]	= React.useState({}); 
	const [uFilterObj,setFilterObj]		= React.useState({});
	const [uFirstload,setFirstload]		= React.useState("YA");
	const [uSortedObj,setSortedObj]		= React.useState({});
	//const uFilterObj		  		= useSelector(state => state.gFilterObj) || {};

	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uRowselect,setRowselect]		= React.useState(-1);
	const [uIDselect,setIDselect]		= React.useState(0);

	const uDatacabangArr				= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const [uDatadefaultArr,setDatadefaultArr]= React.useState([]);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uTerapimainArr,setTerapimainArr]= React.useState([]); 
	const [uDatasumObj,setDatasumObj]	= React.useState({});
	const [uEfekview2,setEfekview2] 	= React.useState(false);
	//--END VIEWS_VARS--*/

	//--FORM_VARS--/
	const [uIsDlgformshow,setDlgformshow]	= React.useState(false);
	const [uHeaderDlgform,setHeaderDlgform]	= React.useState("");
	const [uFormdataObj,setFormdataObj]		= React.useState({});
	//--END FORM_VARS--/

	//--DOM_VARS--/
	const uElJmlData					= document.getElementById("idjmldata");
	const [uElBtnsimpan,setElBtnsimpan]	= React.useState(document.getElementById("btnDialogSimpan"));
	const fileType 				= "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	const fileExtension 		= ".xlsx";
	//--END DOM_VARS--/

	//--SETTING_CETAK--/
	const uSettingcetakObj		= JSON.parse(localStorage.getItem("settingnota")) || {};
	const uHTMLstylelaporan		= useSelector(state => state.gHTMLstyleLaporan);
	const uFrameExport 			= document.getElementById("ifmcontentstoprint");
	//--END SETTING_CETAK--/

	//--HANDEL--/
	const hdlToggleDlgform = () => { setDlgformshow(false) }
	const hdlKlikDlgsimpan = () => {
		//--VALIDASI_FILTER--/
		let vElfocus	= document.getElementById("inpcabangid");
		if(parseInt(uFormdataObj.cabang_id||"0") <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Cabang Harus Dipilih !");
			return
		}
		vElfocus	= document.getElementById("inpjenis");
		if((uFormdataObj.jenis||"").trim() !== "TAHUN"
			&& (uFormdataObj.jenis||"").trim() !== "BULAN"
			&& (uFormdataObj.jenis||"").trim() !== "TANGGAL") {
			vElfocus && vElfocus.focus();
			showToast("Jenis Periode Laporan Tidak Valid !");
			return
		}

		let vTanggal;
		if((uFormdataObj.jenis||"").trim() === "TAHUN") {
			vElfocus	= document.getElementById("inptahun");
			vTanggal  	= uFormdataObj.thn+"-01-01"; 
			if(!UFunc.isDateValid(vTanggal)) {
				vElfocus && vElfocus.focus();
				showToast("Periode Tahun Laporan Tidak Valid ! "); return
			}
		} else if((uFormdataObj.jenis||"").trim() === "BULAN") {
			vElfocus	= document.getElementById("inpbulanid");
			vTanggal  	= uFormdataObj.thn+"-"+uFormdataObj.bln+"-01"; 
			if(!UFunc.isDateValid(vTanggal)) {
				vElfocus && vElfocus.focus();
				showToast("Periode Bulan-Tahun Laporan Tidak Valid !"); return
			}
		} else {
			vElfocus	= document.getElementById("inptgl");
			vTanggal  	= uFormdataObj.thn+"-"+uFormdataObj.bln+"-"+uFormdataObj.tgl; 
			if(!UFunc.isDateValid(vTanggal)) {
				vElfocus && vElfocus.focus();
				showToast("Periode Tanggal-Bulan-Tahun Laporan Tidak Valid !"); return
			}
		}

		const vTanggalDT	= UFunc.toDate(vTanggal);
		if(UFunc.DateIsBeyond(vTanggalDT)) {
			vElfocus && vElfocus.focus();
			showToast("Periode Laporan Melewati Tanggal SAAT INI ! "); return
		}
		//alert(vTanggalDT);return;
		//--END VALIDASI_FILTER--/

		setDataloaded(false);
		apiLoaddata();
	}
	const hdlKlikSort = (_NAMAKOL) => {
		_NAMAKOL		= (_NAMAKOL||"").toUpperCase();
		const vNamenow	= (uSortedObj.nama||"").toUpperCase();
		const vSortnow	= (uSortedObj.jenis||"").toUpperCase();

		const vSortedObj		= uSortedObj;
		vSortedObj.init_aktif 	= "YA";
		if(vNamenow==="" || vNamenow !== _NAMAKOL) {
			vSortedObj.nama 	= _NAMAKOL.toLowerCase();
			vSortedObj.jenis 	= "ASCENDING";
		} else if(vNamenow===_NAMAKOL) {
			if(vSortnow==="ASCENDING")
				vSortedObj.jenis = "DESCENDING";
			else if(vSortnow==="DESCENDING") {
				 vSortedObj.nama 	= "";
				 vSortedObj.jenis 	= "";
			}
		}
		vSortedObj.init_aktif 	= undefined;

		setSortedObj(vSortedObj);
		setEfekview(!uEfekview);
	}
	const hdlKlikCetak = () => {
		if(uDatamainArr.length <= 0) return;

		const vContent 	= contentCetak();
		if(vContent === "") return
		//console.log("(Lapterapi - hdlKlikCetak) vContent = "+vContent)

		var pri 		= uFrameExport.contentWindow;
		pri.document.open();
		pri.document.write(vContent);
		pri.document.close();
		pri.window.focus();
		pri.window.print();
	}
	const hdlKlikExcel = () => {
		if(uDatamainArr.length <= 0) return;

		if(uFilterObj.jenis === "TAHUN") {
			excelTahunall(); return 
		}
		if(uFilterObj.jenis === "TANGGAL") {
			excelTanggalall(); return
		}
		if(uFilterObj.jenis === "BULAN") {
			if(parseInt(uFilterObj.terapimain_id||"0") > 0) {
				excelBulanterapi(); return
			}

			excelBulanall(); return
		}
	}
	//--END HANDEL--/

	//--INIT--/
	const initResettampilan = () => {
		setCaptionObj({}); setDatamainArr([]);// setJmlData(0);
		setFilterObj({}); setSortedObj({});
	}
	const initJmldata = () => {
		uElJmlData 
			&& (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	}
	const excelTanggalall = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		
		const vTerapitext	= "SEMUA TERAPI";

		const vTgl		= parseInt((uFilterObj||{}).tgl)||0;
		const vBulanID	= parseInt((uFilterObj||{}).bln)||0;
		const vTahun	= parseInt((uFilterObj||{}).thn)||0;

		const vColspan		= 15;

		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			terapi_caption : "",
			pasien_caption : "",
			tarif_terapi: "",
			b_fxd_lab: "",
			b_fxd_terukur: "",
			b_fxd_apd: "",
			b_fxd_charge: "",
			b_fxd_diskon: "",
			b_var_pajak: "",
			b_var_lain: "",
			b_dokter_diskon: "",
			nilai_fee_man: "",
			nilai_fee_klinik: "",
			nilai_fee_dokter: "",
		};
		vDatasetsArr.push(vTmpObj);

		vRowcount++;
		uDatamainArr.map((vItems,vKeys)=>{
			const {
				pasien_caption,terapi_caption,tarif_terapi,
				terapi_main,terapi_sub,
				b_fxd_lab,b_fxd_terukur,b_fxd_apd,b_fxd_charge,
				b_fxd_diskon,b_var_pajak,b_var_lain,b_dokter_diskon,
				nilai_fee_man,nilai_fee_klinik,nilai_fee_dokter,
			} = vItems;

			vColposwidth = (terapi_caption||"").length > vColposwidth 
				? (terapi_caption||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				terapi_caption: (terapi_caption||"Undf Terapi"),
				pasien_caption: (pasien_caption||"Undf Pasien"),
				tarif_terapi: { v:parseFloat(tarif_terapi), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_lab: { v:parseFloat(b_fxd_lab), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_terukur: { v:parseFloat(b_fxd_terukur), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_apd: { v:parseFloat(b_fxd_apd), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_charge: { v:parseFloat(b_fxd_charge), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_diskon: { v:parseFloat(b_fxd_diskon), t:"n", s:{numFmt: "#,##0"} },
				b_var_pajak: { v:parseFloat(b_var_pajak), t:"n", s:{numFmt: "#,##0"} },
				b_var_lain: { v:parseFloat(b_var_lain), t:"n", s:{numFmt: "#,##0"} },
				b_dokter_diskon: { v:parseFloat(b_dokter_diskon), t:"n", s:{numFmt: "#,##0"} },
				nilai_fee_man: { v:parseFloat(nilai_fee_man), t:"n", s:{numFmt: "#,##0"} },
				nilai_fee_klinik: { v:parseFloat(nilai_fee_klinik), t:"n", s:{numFmt: "#,##0"} },
				nilai_fee_dokter: { v:parseFloat(nilai_fee_dokter), t:"n", s:{numFmt: "#,##0"} },
			}
			vDatasetsArr.push(vTmpObj);
			vRowcount++;
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			terapi_caption: "",
			pasien_caption: "",
			tarif_terapi: { v:parseFloat(uDatasumObj.tarif_terapi)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_lab: { v:parseFloat(uDatasumObj.b_fxd_lab)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_terukur: { v:parseFloat(uDatasumObj.b_fxd_terukur)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_apd: { v:parseFloat(uDatasumObj.b_fxd_apd)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_charge: { v:parseFloat(uDatasumObj.b_fxd_charge)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_diskon: { v:parseFloat(uDatasumObj.b_fxd_diskon)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_var_pajak: { v:parseFloat(uDatasumObj.b_var_pajak)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_var_lain: { v:parseFloat(uDatasumObj.b_var_lain)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_dokter_diskon: { v:parseFloat(uDatasumObj.b_dokter_diskon)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_fee_man: { v:parseFloat(uDatasumObj.nilai_fee_man)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_fee_klinik: { v:parseFloat(uDatasumObj.nilai_fee_klinik)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_fee_dokter: { v:parseFloat(uDatasumObj.nilai_fee_dokter)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:43}]
		const wscols	= [
			{wpx:40},
			{wch:vColposwidth},
			{wpx:200},
			{wpx:100},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:100},
			{wpx:90},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 13}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile 	= 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPTERAPI_"+
			UFunc.leadZero(vTgl)+
			(cBulanPendek[vBulanID-1]).toUpperCase()+vTahun+
		"";
		const vSheetlabel 	= UFunc.leadZero(vTgl)+(cBulanPendek[vBulanID-1])+vTahun;
		const ws 			= XLSX.utils.json_to_sheet(vDatasetsArr);

		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode Tgl "+UFunc.leadZero(vTgl)+" "+(cBulanPendek[vBulanID-1]).toUpperCase()+" "+vTahun+
			(uDatacabangArr.length > 1 ? "\r\nCabang: "+vCabangtext : "" )+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Terapi",s:{alignment:{horizontal:"left",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Nama Pasien",s:{alignment:{horizontal:"left",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Tarif Terapi (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Laboratiorium (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Terukur (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.APD (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Charge (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Program Diskon (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Pajak (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Lain2 (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Diskon DRG (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Fee Manajemen (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Fee Klink (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Fee Dokter (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
		];

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	const excelBulanall = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		
		const vTerapitext	= "SEMUA TERAPI";

		const vBulanID		= parseInt((uFilterObj||{}).bln)||0;
		const vTahun		= parseInt((uFilterObj||{}).thn)||0;

		const vColspan		= 14;

		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			terapi_caption : "",
			tarif_terapi : "",
			b_fxd_lab : "",
			b_fxd_terukur : "",
			b_fxd_apd : "",
			b_fxd_charge : "",
			b_fxd_diskon : "",
			b_var_pajak : "",
			b_var_lain : "",
			b_dokter_diskon : "",
			nilai_fee_man : "",
			nilai_fee_klinik : "",
			nilai_fee_dokter : "",
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;

		uDatamainArr.forEach((vItems,vKeys)=>{
			const {
				terapi_caption,terapi_main,tarif_terapi,
				b_fxd_lab,b_fxd_terukur,b_fxd_apd,b_fxd_charge,
				b_fxd_diskon,b_var_pajak,b_var_lain,b_dokter_diskon,
				nilai_fee_man,nilai_fee_klinik,nilai_fee_dokter,
			} = vItems;

			vRowcount++;
			vColposwidth = (terapi_caption||"").length > vColposwidth 
				? (terapi_caption||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				terapi_caption: (terapi_caption||"Undf Terapi"),
				tarif_terapi: { v:parseFloat(tarif_terapi), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_lab: { v:parseFloat(b_fxd_lab), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_terukur: { v:parseFloat(b_fxd_terukur), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_apd: { v:parseFloat(b_fxd_apd), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_charge: { v:parseFloat(b_fxd_charge), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_diskon: { v:parseFloat(b_fxd_diskon), t:"n", s:{numFmt: "#,##0"} },
				b_var_pajak: { v:parseFloat(b_var_pajak), t:"n", s:{numFmt: "#,##0"} },
				b_var_lain: { v:parseFloat(b_var_lain), t:"n", s:{numFmt: "#,##0"} },
				b_dokter_diskon: { v:parseFloat(b_dokter_diskon), t:"n", s:{numFmt: "#,##0"} },
				nilai_fee_man: { v:parseFloat(nilai_fee_man), t:"n", s:{numFmt: "#,##0"} },
				nilai_fee_klinik: { v:parseFloat(nilai_fee_klinik), t:"n", s:{numFmt: "#,##0"} },
				nilai_fee_dokter: { v:parseFloat(nilai_fee_dokter), t:"n", s:{numFmt: "#,##0"} },
			}
			vDatasetsArr.push(vTmpObj);
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			terapi_caption: "",
			tarif_terapi: { v:parseFloat(uDatasumObj.tarif_terapi)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_lab: { v:parseFloat(uDatasumObj.b_fxd_lab)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_terukur: { v:parseFloat(uDatasumObj.b_fxd_terukur)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_apd: { v:parseFloat(uDatasumObj.b_fxd_apd)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_charge: { v:parseFloat(uDatasumObj.b_fxd_charge)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_diskon: { v:parseFloat(uDatasumObj.b_fxd_diskon)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_var_pajak: { v:parseFloat(uDatasumObj.b_var_pajak)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_var_lain: { v:parseFloat(uDatasumObj.b_var_lain)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_dokter_diskon: { v:parseFloat(uDatasumObj.b_dokter_diskon)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_fee_man: { v:parseFloat(uDatasumObj.nilai_fee_man)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_fee_klinik: { v:parseFloat(uDatasumObj.nilai_fee_klinik)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_fee_dokter: { v:parseFloat(uDatasumObj.nilai_fee_dokter)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:43}]
		const wscols	= [
			{wpx:40},
			{wch:vColposwidth},
			{wpx:100},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:100},
			{wpx:90},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 13}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile 	= 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPTERAPI_"+
			(cBulanPendek[vBulanID-1]).toUpperCase()+vTahun+
		"";
		const vSheetlabel 	= (cBulanPendek[vBulanID-1])+vTahun;
		const ws 			= XLSX.utils.json_to_sheet(vDatasetsArr);

		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode Bulan "+(cBulanPendek[vBulanID-1]).toUpperCase()+" "+vTahun+
			(uDatacabangArr.length > 1 ? "\r\nCabang: "+vCabangtext : "" )+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Terapi",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Tarif Terapi (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Laboratiorium (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Terukur (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.APD (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Charge (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Program Diskon (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Pajak (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Lain2 (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Diskon DRG (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Fee Manajemen (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Fee Klink (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Fee Dokter (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
		];

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	const excelBulanterapi = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		
		const vTerapiIdx	= UFunc.getObjectIndeks(uTerapimainArr,uFilterObj.terapimain_id);
		const vTerapitext	= uTerapimainArr[vTerapiIdx].nama_terapi;

		const vBulanID		= parseInt((uFilterObj||{}).bln)||0;
		const vTahun		= parseInt((uFilterObj||{}).thn)||0;

		const vColspan		= 16;

		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			tanggal : "",
			terapi_caption : "",
			pasien_caption : "",
			tarif_terapi : "",
			b_fxd_lab : "",
			b_fxd_terukur : "",
			b_fxd_apd : "",
			b_fxd_charge : "",
			b_fxd_diskon : "",
			b_var_pajak : "",
			b_var_lain : "",
			b_dokter_diskon : "",
			nilai_fee_man : "",
			nilai_fee_klinik : "",
			nilai_fee_dokter : "",
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;

		uDatamainArr.forEach((vItems,vKeys)=>{
			const {
				tanggal,pasien_caption,terapi_main,terapi_sub,
				tarif_terapi,b_fxd_lab,b_fxd_terukur,b_fxd_apd,b_fxd_charge,
				b_fxd_diskon,b_var_pajak,b_var_lain,b_dokter_diskon,
				nilai_fee_man,nilai_fee_klinik,nilai_fee_dokter,
			} = vItems;

			vColposwidth = (terapi_main||"").length > vColposwidth 
				? (terapi_main||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				tanggal : {v:tanggal,t:"d",s:{alignment:{horizontal:"left"}}},
				terapi_caption: (terapi_main||"Undf Terapi").toUpperCase()+" "+(terapi_sub||"Undf Sub Terapi"),
				pasien_caption: (pasien_caption||"Undf Terapi"),
				tarif_terapi: { v:parseFloat(tarif_terapi), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_lab: { v:parseFloat(b_fxd_lab), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_terukur: { v:parseFloat(b_fxd_terukur), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_apd: { v:parseFloat(b_fxd_apd), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_charge: { v:parseFloat(b_fxd_charge), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_diskon: { v:parseFloat(b_fxd_diskon), t:"n", s:{numFmt: "#,##0"} },
				b_var_pajak: { v:parseFloat(b_var_pajak), t:"n", s:{numFmt: "#,##0"} },
				b_var_lain: { v:parseFloat(b_var_lain), t:"n", s:{numFmt: "#,##0"} },
				b_dokter_diskon: { v:parseFloat(b_dokter_diskon), t:"n", s:{numFmt: "#,##0"} },
				nilai_fee_man: { v:parseFloat(nilai_fee_man), t:"n", s:{numFmt: "#,##0"} },
				nilai_fee_klinik: { v:parseFloat(nilai_fee_klinik), t:"n", s:{numFmt: "#,##0"} },
				nilai_fee_dokter: { v:parseFloat(nilai_fee_dokter), t:"n", s:{numFmt: "#,##0"} },
			}
			vDatasetsArr.push(vTmpObj);
			vRowcount++;
		}); 

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			tanggal: "",
			terapi_caption: "",
			pasien_caption: "",
			tarif_terapi: { v:parseFloat(uDatasumObj.tarif_terapi)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_lab: { v:parseFloat(uDatasumObj.b_fxd_lab)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_terukur: { v:parseFloat(uDatasumObj.b_fxd_terukur)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_apd: { v:parseFloat(uDatasumObj.b_fxd_apd)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_charge: { v:parseFloat(uDatasumObj.b_fxd_charge)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_diskon: { v:parseFloat(uDatasumObj.b_fxd_diskon)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_var_pajak: { v:parseFloat(uDatasumObj.b_var_pajak)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_var_lain: { v:parseFloat(uDatasumObj.b_var_lain)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_dokter_diskon: { v:parseFloat(uDatasumObj.b_dokter_diskon)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_fee_man: { v:parseFloat(uDatasumObj.nilai_fee_man)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_fee_klinik: { v:parseFloat(uDatasumObj.nilai_fee_klinik)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_fee_dokter: { v:parseFloat(uDatasumObj.nilai_fee_dokter)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:43}]
		const wscols	= [
			{wpx:40},
			{wpx:90},
			{wch:vColposwidth},
			{wpx:170},
			{wpx:100},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:100},
			{wpx:90},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 13}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile 	= 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPTERAPI_"+
			(cBulanPendek[vBulanID-1]).toUpperCase()+vTahun+
		"";
		const vSheetlabel 	= (cBulanPendek[vBulanID-1])+vTahun;
		const ws 			= XLSX.utils.json_to_sheet(vDatasetsArr);

		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode Bulan "+(cBulanPendek[vBulanID-1]).toUpperCase()+" "+vTahun+
			(uDatacabangArr.length > 1 ? "\r\nCabang: "+vCabangtext : "" )+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Tangggal",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Terapi",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Pasien",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Tarif Terapi (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Laboratiorium (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Terukur (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.APD (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Charge (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Program Diskon (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Pajak (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Lain2 (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Diskon DRG (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Fee Manajemen (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Fee Klink (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Fee Dokter (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
		];

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	const excelTahunall = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		const vTerapitext	= "SEMUA TERAPI";

		const vTahun		= parseInt((uFilterObj||{}).thn)||0;

		let vColspan		= 14;
		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			bulan_caption : "",
			tarif_terapi : "",
			b_fxd_lab : "",
			b_fxd_terukur : "",
			b_fxd_apd : "",
			b_fxd_charge : "",
			b_fxd_diskon : "",
			b_var_pajak : "",
			b_var_lain : "",
			b_dokter_diskon : "",
			nilai_fee_man : "",
			nilai_fee_klinik : "",
			nilai_fee_dokter : "",
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;

		uDatamainArr.forEach((vItems,vKeys)=>{
			const {
				bulan_caption,bulan_idx,tarif_terapi,
				b_fxd_lab,b_fxd_terukur,b_fxd_apd,b_fxd_charge,
				b_fxd_diskon,b_var_pajak,b_var_lain,b_dokter_diskon,
				nilai_fee_man,nilai_fee_klinik,nilai_fee_dokter,
			} = vItems;

			vColposwidth = (bulan_caption||"").length > vColposwidth 
				? (bulan_caption||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				bulan_caption: (bulan_caption||"Undf Terapi"),
				tarif_terapi: { v:parseFloat(tarif_terapi), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_lab: { v:parseFloat(b_fxd_lab), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_terukur: { v:parseFloat(b_fxd_terukur), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_apd: { v:parseFloat(b_fxd_apd), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_charge: { v:parseFloat(b_fxd_charge), t:"n", s:{numFmt: "#,##0"} },
				b_fxd_diskon: { v:parseFloat(b_fxd_diskon), t:"n", s:{numFmt: "#,##0"} },
				b_var_pajak: { v:parseFloat(b_var_pajak), t:"n", s:{numFmt: "#,##0"} },
				b_var_lain: { v:parseFloat(b_var_lain), t:"n", s:{numFmt: "#,##0"} },
				b_dokter_diskon: { v:parseFloat(b_dokter_diskon), t:"n", s:{numFmt: "#,##0"} },
				nilai_fee_man: { v:parseFloat(nilai_fee_man), t:"n", s:{numFmt: "#,##0.#0"} },
				nilai_fee_klinik: { v:parseFloat(nilai_fee_klinik), t:"n", s:{numFmt: "#,##0.#0"} },
				nilai_fee_dokter: { v:parseFloat(nilai_fee_dokter), t:"n", s:{numFmt: "#,##0.#0"} },
			}
			vDatasetsArr.push(vTmpObj);
			vRowcount++;
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			bulan_caption: "",
			tarif_terapi: { v:parseFloat(uDatasumObj.tarif_terapi)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_lab: { v:parseFloat(uDatasumObj.b_fxd_lab)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_terukur: { v:parseFloat(uDatasumObj.b_fxd_terukur)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_apd: { v:parseFloat(uDatasumObj.b_fxd_apd)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_charge: { v:parseFloat(uDatasumObj.b_fxd_charge)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_fxd_diskon: { v:parseFloat(uDatasumObj.b_fxd_diskon)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_var_pajak: { v:parseFloat(uDatasumObj.b_var_pajak)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_var_lain: { v:parseFloat(uDatasumObj.b_var_lain)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			b_dokter_diskon: { v:parseFloat(uDatasumObj.b_dokter_diskon)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_fee_man: { v:parseFloat(uDatasumObj.nilai_fee_man)||0, t:"n", s:{numFmt: "#,##0.#0",font:{bold:true} } },
			nilai_fee_klinik: { v:parseFloat(uDatasumObj.nilai_fee_klinik)||0, t:"n", s:{numFmt: "#,##0.#0",font:{bold:true} } },
			nilai_fee_dokter: { v:parseFloat(uDatasumObj.nilai_fee_dokter)||0, t:"n", s:{numFmt: "#,##0.#0",font:{bold:true} } },
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:51}]
		const wscols	= [
			{wpx:40},
			{wch:vColposwidth},
			{wpx:100},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:100},
			{wpx:90},
		];
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 13}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile 	= 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPTERAPI_"+
			vTahun+
		"";
		const vSheetlabel 	= vTahun.toString();
		const ws 			= XLSX.utils.json_to_sheet(vDatasetsArr);

		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode Tahun "+vTahun+
			(uDatacabangArr.length > 1 ? "\r\nCabang: "+vCabangtext : "" )+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Bulan",s:{alignment:{horizontal:"left",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Tarif Terapi (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Laboratiorium\r\n(Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Terukur (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.APD (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Charge (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Program Diskon (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Pajak (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"B.Lain2 (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Diskon DRG (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Fee Manajemen\r\n(Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Fee Klink (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Fee Dokter (Rp)",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
		];
		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	//--END INIT--/

	//--CONTENT--/
	const contentDlgform = () => {
		if(!uIsDlgformshow) return (<></>)//>

		const vJmlTahunlaporan	= parseInt(uSystemsettingObj.jml_tahun_laporan)||5;
		const vCabangID 		= uFormdataObj.cabang_id || 0;
		const vCabangviewArr	= uTokenObj.userhak==="FREEROLE" ? uDatacabangArr
			: uDatacabangArr.filter(vItems=>(uTokenObj.user_cabangarr || []).includes(vItems.id.toString()))
		const vTahunnow			= (new Date()).getFullYear();
		const vTerapiviewArr	= uTerapimainArr;

		return (
		<CForm>
		{uDatacabangArr.length > 1 && (
		<CRow className="my-2">
		<CCol xs="4">Cabang</CCol>
		<CCol className="text-end">
		<CFormSelect size="sm"
			value={uFormdataObj.cabang_id||0}
			onChange={(e)=>setFormdataObj({...uFormdataObj,cabang_id:e.target.value})}
			id="inpcabangid">
			{vCabangviewArr.map((vItems,vKeys)=>{
				const {
					id,cabang_nama
				} = vItems

				return (
				<option value={id} key={vKeys}>{(cabang_nama||"UNDF").toUpperCase()}</option>
				)
			})}
			</CFormSelect>
		</CCol>
		</CRow>
		)}

		<CRow className="my-2">
		<CCol xs="4">Jenis Periode</CCol>
		<CCol className="text-end">
		<CFormSelect size="sm"
			value={uFormdataObj.jenis}
			onChange={(e)=>setFormdataObj({...uFormdataObj,jenis:e.target.value})}
			id="inpjenis">
			<option value="TANGGAL">per TANGGAL</option>
			<option value="BULAN">per BULAN</option>
			<option value="TAHUN">per TAHUN</option>
			</CFormSelect>
		</CCol>
		</CRow>

		{(uFormdataObj.jenis||"TANGGAL")==="TANGGAL" && (
		<CRow className="my-2">
		<CCol xs="4">{uBahasaObj.word_tanggal||"Tanggal"}</CCol>
		<CCol className="text-end">
			<CInputGroup size="sm">
			<CFormSelect size="sm"
				value={uFormdataObj.tgl || UFunc.leadZero((new Date()).getDate())}
				onChange={(e)=>setFormdataObj({...uFormdataObj,tgl:e.target.value})}
				id="inptgl">
			{[...new Array(31)].map((vItems,vKeys)=>{
				return (
				<option value={UFunc.leadZero(vKeys+1)} key={vKeys}>
				{UFunc.leadZero(vKeys+1)}
				</option>
				)
			})}
			</CFormSelect>
			&nbsp;
			<CFormSelect size="sm"
				value={uFormdataObj.bln || UFunc.leadZero((new Date()).getMonth() + 1)}
				onChange={(e)=>setFormdataObj({...uFormdataObj,bln:e.target.value})}
				id="inpbulanid">
				{cBulanPendek.map((vItems,vKeys) => {
					return (
						<option value={UFunc.leadZero(vKeys+1)} key={vKeys}>
						{(vItems||"UNDF").toUpperCase()}
						</option>
					)					
				})}
			</CFormSelect>
			&nbsp;
			<CFormSelect size="sm"
				value={uFormdataObj.thn || UFunc.leadZero((new Date()).getFullYear())}
				onChange={(e)=>setFormdataObj({...uFormdataObj,thn:e.target.value})}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e, "btnDialogSimpan")}
				id="inpbulantahun">
				{(() => {
					let vTmpArr 	= [];
					for(var vIdx=0;vIdx < vJmlTahunlaporan;vIdx++) {
						vTmpArr.push(
						<option value={(vTahunnow - vIdx)} key={vIdx}>{(vTahunnow - vIdx)}</option>
						)
					}
					return vTmpArr;
				})()}
			</CFormSelect>
			</CInputGroup>
		</CCol>
		</CRow>
		)}

		{(uFormdataObj.jenis||"TANGGAL")==="BULAN" && (
		<CRow className="my-2">
		<CCol xs="4">{uBahasaObj.word_bulan||"Bulan"}</CCol>
		<CCol className="text-end">
			<CInputGroup size="sm">
			<CFormSelect size="sm"
				style={{width:"auto"}}
				value={uFormdataObj.bln || UFunc.leadZero((new Date()).getMonth() + 1)}
				onChange={(e)=>setFormdataObj({...uFormdataObj,bln:e.target.value})}
				id="inpbulanid">
				{cBulanPanjang.map((vItems,vKeys) => {
					return (
						<option value={UFunc.leadZero(vKeys+1)} key={vKeys}>
						{(vItems||"UNDF").toUpperCase()}
						</option>
					)					
				})}
			</CFormSelect>
			&nbsp;
			<CFormSelect size="sm"
				style={{width:"auto"}}
				value={uFormdataObj.thn || UFunc.leadZero((new Date()).getFullYear())}
				onChange={(e)=>setFormdataObj({...uFormdataObj,thn:e.target.value})}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e, "btnDialogSimpan")}
				id="inpbulantahun">
				{[...new Array(vJmlTahunlaporan)].map((vItems,vKeys)=>{
					return (
					<option value={(vTahunnow - vKeys)} key={vKeys}>{(vTahunnow - vKeys)}</option>
					)
				})}
			</CFormSelect>
			</CInputGroup>
		</CCol>
		</CRow>
		)}

		{(uFormdataObj.jenis||"TANGGAL")==="TAHUN" && (
		<CRow className="my-2">
		<CCol xs="4">Tahun</CCol>
		<CCol xs="8" lg="4" className="text-end">
			<CInputGroup size="sm">
			<CFormSelect size="sm"
				value={uFormdataObj.thn || UFunc.leadZero((new Date()).getFullYear())}
				onChange={(e)=>setFormdataObj({...uFormdataObj,thn:e.target.value})}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e, "btnDialogSimpan")}
				id="inptahun">
				{[...new Array(vJmlTahunlaporan)].map((vItems,vKeys)=>{
					return (
					<option value={(vTahunnow - vKeys)} key={vKeys}>{(vTahunnow - vKeys)}</option>
					)
				})}
			</CFormSelect>
			</CInputGroup>
		</CCol>
		<CCol md="3"/>
		</CRow>
		)}

		{(uFormdataObj.jenis||"TANGGAL")==="BULAN" && (
		<CRow className="my-2">
		<CCol xs="4">Pilih Terapi</CCol>
		<CCol className="text-end">
		<CFormSelect size="sm"
			value={uFormdataObj.terapimain_id}
			onChange={(e)=>setFormdataObj({...uFormdataObj,terapimain_id:e.target.value})}
			onKeyDown={(e)=>UFunc.hdlKeyDownInput(e, "btnDialogSimpan")}
			id="inpterapimainid">
			<option value="0">-- SEMUA TERAPI --</option>
			{(uFormdataObj.jenis||"TANGGAL")==="BULAN" && (
			<>
			{vTerapiviewArr.map((vItems,vKeys)=>{
				const { id,nama_terapi } = vItems

				return (
				<option value={id} key={vKeys} className="text-capitalize">{(nama_terapi||"UNDF")}</option>
				)
			})}
			</>
			)}
			</CFormSelect>
		</CCol>
		</CRow>
		)}

		</CForm>
		)//>
	}
	const contentLaporan = () => {
		if(!uIsDataloaded) return ""

		if(uJmlData <= 0) return (
			<div className="mx-md-5 px-lg-5">
			&middot;&middot; {uBahasaObj.caption_dataempty||"Data Tidak Ada"} &middot;&middot;
			</div>
		)//>

		//console.log("(Lapterapi - contentLaporan) uFilterObj.jenis => "+uFilterObj.jenis);
		if(uFilterObj.jenis === "TAHUN") {
			return contentTahunall();
		}
		if(uFilterObj.jenis === "TANGGAL") {
			return contentTanggalall();
		}
		if(uFilterObj.jenis === "BULAN") {
			if(parseInt(uFilterObj.terapimain_id||"0") > 0)
				return contentBulanterapi();

			return contentBulanall();
		}

		return ""
	}
	const contentTanggalall = () => {
		if(uFilterObj.jenis !== "TANGGAL") return ""
		if(parseInt(uFilterObj.terapimain_id||"") > 0) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);

		const vStylekolfixed = {
			position: "sticky",
			left: 0,
			background: "#f0f0f0",
			zIndex: 1,
			borderRight:"1px solid #DCDCDC",
		}
		const vWidthtabel = 1900;

		const vDatamainArr	= uDatamainArr.slice(vMin,(vMax));

		return (
		<div style={{overflowX:"auto"}} className="" id="iddivtabel">
		<table style={{width:vWidthtabel}}
			className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="text-center align-top classfontsmaller">
			<th width={40} className="px-1 border" style={vStylekolfixed}><small>No</small></th>

			<th className="px-1 text-start border" style={{...vStylekolfixed,left:40,minWidth:250}}><small>{uBahasaObj.word_terapi||"Terapi"}</small></th>
			<th className="px-1 text-start border" width={250}><small>{uBahasaObj.word_pasien||"Pasien"}</small></th>
			
			<th width={120} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="tarif_terapi" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_hargaterapi||"H.Terapi"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("tarif_terapi")}>
				<CIcon icon={((uSortedObj.nama||"")==="tarif_terapi" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>

			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_lab" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_blab||"B.Lab"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_lab")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_lab" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_terukur" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bterukur||"B.Terukur"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_terukur")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_terukur" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_apd" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bapd||"B.APD"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_apd")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_apd" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_charge" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bcharge||"B.Charge"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_charge")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_charge" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_diskon" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_progdiskon||"Prog.Diskon"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_diskon")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_diskon" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_var_pajak" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bpajak||"B.Pajak"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_var_pajak")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_var_pajak" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_var_lain" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_blain||"B.Lain2"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_var_lain")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_var_lain" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_dokter_diskon" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bdiskondokter||"Diskon Dokter"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_dokter_diskon")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_dokter_diskon" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="nilai_fee_man" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_feemanajemen||"Fee Manajemen"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("nilai_fee_man")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_fee_man" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="nilai_fee_klinik" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_feeklinik||"Fee Klinik"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("nilai_fee_klinik")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_fee_klinik" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="nilai_fee_dokter" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_feedokter||"Fee Dokter"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("nilai_fee_dokter")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_fee_dokter" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			</tr>
		</thead>

		<tbody>
		{vDatamainArr.map((vItems,vKeys)=>{
			const {
				terapi_main,terapi_sub,pasien_caption,tarif_terapi,
				b_fxd_lab,b_fxd_terukur,b_fxd_apd,b_fxd_charge,
				b_fxd_diskon,b_var_pajak,b_var_lain,b_dokter_diskon,
				nilai_fee_man,nilai_fee_klinik,nilai_fee_dokter,
			} = vItems;

			vNumber++;
			return (
			<tr key={vKeys} className="align-top text-end">
			<td className="px-1" style={vStylekolfixed}>{vNumber}.</td>
			
			<td className="px-1 text-start" style={{...vStylekolfixed,left:40}}>
				<b className="me-1">{(terapi_main||"UNDF")}</b>
				<i>{(terapi_sub)}</i>
			</td>
			<td className="px-1 text-start text-capitalize text-info">{(pasien_caption||"UNDF")}</td>
			
			<td className="px-1 text-primary">{UFunc.formatAngka(tarif_terapi)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_lab)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_terukur)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_apd)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_charge)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_diskon)}</td>
			<td className="px-1">{UFunc.formatAngka(b_var_pajak)}</td>
			<td className="px-1">{UFunc.formatAngka(b_var_lain)}</td>
			<td className="px-1">{UFunc.formatAngka(b_dokter_diskon)}</td>

			<td className="px-1">
				<span className={parseFloat(nilai_fee_man||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_fee_man||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_fee_man)}
				<span className={parseFloat(nilai_fee_man||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(nilai_fee_klinik||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_fee_klinik||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_fee_klinik)}
				<span className={parseFloat(nilai_fee_klinik||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(nilai_fee_dokter||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_fee_dokter||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_fee_dokter)}
				<span className={parseFloat(nilai_fee_dokter||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			</tr>
			);
		})}
		</tbody>

		<tfoot>
		<tr className="fw-bolder bg-primary text-white align-top text-end">
			<td colSpan={2} className="px-1 bg-primary text-center text-uppercase" style={vStylekolfixed}>{uBahasaObj.word_jumlah||"JUMLAH"}</td>
			<td className="px-1"/>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.tarif_terapi))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_lab))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_terukur))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_apd))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_charge))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_diskon))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_var_pajak))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_var_lain))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_dokter_diskon))}
			</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumObj.nilai_fee_man||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_man))}
				<span className={parseFloat(uDatasumObj.nilai_fee_man||"0")>=0 ? "d-none":""}>)</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumObj.nilai_fee_klinik||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_klinik))}
				<span className={parseFloat(uDatasumObj.nilai_fee_klinik||"0")>=0 ? "d-none":""}>)</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumObj.nilai_fee_dokter||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_dokter))}
				<span className={parseFloat(uDatasumObj.nilai_fee_dokter||"0")>=0 ? "d-none":""}>)</span>
			</td>
		</tr>
		</tfoot>
		</table>
		</div>
		)//>
	}
	const contentBulanall = () => {
		if(uFilterObj.jenis !== "BULAN") return ""
		if(parseInt(uFilterObj.terapimain_id||"") > 0) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);

		const vDatamainArr	= uDatamainArr.slice(vMin,(vMax));

		const vStylekolfixed = {
			position: "sticky",
			left: 0,
			background: "#f0f0f0",
			zIndex: 1,
			borderRight:"1px solid #DCDCDC",
		}
		const vWidthtabel = 1700;

		return (
		<div style={{overflowX:"auto"}}
			className=""
			id="iddivtabel">
		<table 
			style={{minWidth:vWidthtabel,width:"100%"}}
			className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="text-center align-top classfontsmaller">
			<th width={35} className="px-1 border" style={vStylekolfixed}>No</th>
			<th className="text-start px-1 border" style={{...vStylekolfixed,left:35,minWidth:250}}>{uBahasaObj.word_terapi||"Terapi"}</th>

			<th width={100} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="tarif_terapi" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_hargaterapi||"H.Terapi"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("tarif_terapi")}>
				<CIcon icon={((uSortedObj.nama||"")==="tarif_terapi" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>

			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_lab" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_blab||"B.Lab"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_lab")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_lab" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_terukur" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bterukur||"B.Terukur"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_terukur")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_terukur" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_apd" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bapd||"B.APD"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_apd")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_apd" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_charge" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bcharge||"B.Charge"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_charge")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_charge" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_diskon" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_progdiskon||"Prog.Diskon"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_diskon")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_diskon" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_var_pajak" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bpajak||"B.Pajak"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_var_pajak")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_var_pajak" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_var_lain" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_blain||"B.Lain2"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_var_lain")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_var_lain" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_dokter_diskon" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bdiskondokter||"Diskon Dokter"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_dokter_diskon")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_dokter_diskon" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="nilai_fee_man" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_feemanajemen||"Fee Manajemen"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("nilai_fee_man")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_fee_man" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="nilai_fee_klinik" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_feeklinik||"Fee Klinik"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("nilai_fee_klinik")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_fee_klinik" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="nilai_fee_dokter" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_feedokter||"Fee Dokter"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("nilai_fee_dokter")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_fee_dokter" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			</tr>
		</thead>

		<tbody>
		{vDatamainArr.map((vItems,vKeys)=>{
			const {
				terapi_caption,tarif_terapi,
				b_fxd_lab,b_fxd_terukur,b_fxd_apd,b_fxd_charge,
				b_fxd_diskon,b_var_pajak,b_var_lain,b_dokter_diskon,
				nilai_fee_man,nilai_fee_klinik,nilai_fee_dokter,
			} = vItems;

			vNumber++;
			return (
			<tr key={vKeys} className="align-top text-end">
			<td className="px-1" style={vStylekolfixed}>{vNumber}.</td>
			<td className="px-1 text-start" style={{...vStylekolfixed,left:35,minWidth:250}}>{(terapi_caption||"UNDF")}</td>
			
			<td className="px-1 text-primary">{UFunc.formatAngka(tarif_terapi)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_lab)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_terukur)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_apd)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_charge)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_diskon)}</td>
			<td className="px-1">{UFunc.formatAngka(b_var_pajak)}</td>
			<td className="px-1">{UFunc.formatAngka(b_var_lain)}</td>
			<td className="px-1">{UFunc.formatAngka(b_dokter_diskon)}</td>

			<td className="px-1">
				<span className={parseFloat(nilai_fee_man||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_fee_man||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_fee_man)}
				<span className={parseFloat(nilai_fee_man||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(nilai_fee_klinik||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_fee_klinik||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_fee_klinik)}
				<span className={parseFloat(nilai_fee_klinik||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(nilai_fee_dokter||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_fee_dokter||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_fee_dokter)}
				<span className={parseFloat(nilai_fee_dokter||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			</tr>
			);
		})}
		</tbody>

		<tfoot>
		<tr className="align-top text-end fw-bolder bg-primary text-white">
			<td colSpan={2} className="px-1 text-center bg-primary text-uppercase" style={{...vStylekolfixed,minWidth:250}}>{uBahasaObj.word_jumlah||"JUMLAH"}</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.tarif_terapi))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_lab))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_terukur))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_apd))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_charge))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_diskon))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_var_pajak))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_var_lain))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_dokter_diskon))}
			</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumObj.nilai_fee_man||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_man))}
				<span className={parseFloat(uDatasumObj.nilai_fee_man||"0")>=0 ? "d-none":""}>)</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumObj.nilai_fee_klinik||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_klinik))}
				<span className={parseFloat(uDatasumObj.nilai_fee_klinik||"0")>=0 ? "d-none":""}>)</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumObj.nilai_fee_dokter||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_dokter))}
				<span className={parseFloat(uDatasumObj.nilai_fee_dokter||"0")>=0 ? "d-none":""}>)</span>
			</td>
		</tr>
		</tfoot>
		</table>
		</div>
		)//>
	}
	const contentBulanterapi = () => {
		if(uFilterObj.jenis !== "BULAN") return ""
		if(parseInt(uFilterObj.terapimain_id||"") <= 0) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);

		const vDatamainArr	= uDatamainArr.slice(vMin,(vMax));

		const vStylekolfixed = {
			position: "sticky",
			left: 0,
			background: "#f0f0f0",
			zIndex: 1,
			borderRight:"1px solid #DCDCDC",
		}
		const vWidthtabel = 1700;

		return (
		<div style={{overflowX:"auto"}} className="" id="iddivtabel">
		<table 
			style={{minWidth:vWidthtabel,width:"100%"}}
			className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="align-top text-center classfontsmaller">
			<th width={40} className="px-1 border" style={vStylekolfixed}>No</th>

			<th width={120} className="px-1 text-start border" style={{...vStylekolfixed,left:40}}>
				{uBahasaObj.word_tanggal||"Tanggal"}
			</th>
			<th className="px-1 text-start border">{uBahasaObj.word_terapi||"Terapi"}</th>

			<th width={100} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="tarif_terapi" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_hargaterapi||"H.Terapi"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("tarif_terapi")}>
				<CIcon icon={((uSortedObj.nama||"")==="tarif_terapi" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_lab" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_blab||"B.Lab"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_lab")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_lab" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_terukur" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bterukur||"B.Terukur"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_terukur")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_terukur" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_apd" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bapd||"B.APD"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_apd")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_apd" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_charge" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bcharge||"B.Charge"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_charge")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_charge" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_diskon" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_progdiskon||"Prog.Diskon"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_diskon")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_diskon" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_var_pajak" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bpajak||"B.Pajak"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_var_pajak")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_var_pajak" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_var_lain" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_blain||"B.Lain2"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_var_lain")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_var_lain" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_dokter_diskon" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bdiskondokter||"Diskon Dokter"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_dokter_diskon")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_dokter_diskon" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="nilai_fee_man" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_feemanajemen||"Fee Manajemen"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("nilai_fee_man")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_fee_man" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="nilai_fee_klinik" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_feeklinik||"Fee Klinik"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("nilai_fee_klinik")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_fee_klinik" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="nilai_fee_dokter" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_feedokter||"Fee Dokter"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("nilai_fee_dokter")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_fee_dokter" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			</tr>
		</thead>

		<tbody>
		{vDatamainArr.map((vItems,vKeys)=>{
			const {
				tanggal,pasien_caption,
				tarif_terapi,terapi_main,terapi_sub,
				b_fxd_lab,b_fxd_terukur,b_fxd_apd,b_fxd_charge,
				b_fxd_diskon,b_var_pajak,b_var_lain,b_dokter_diskon,
				nilai_fee_man,nilai_fee_klinik,nilai_fee_dokter,
			} = vItems;

			vNumber++;
			return (
			<tr key={vKeys} className="align-top text-end">
			<td className="px-1" style={vStylekolfixed}>{vNumber}.</td>
			<td className="px-1 text-start" style={{...vStylekolfixed,left:40}}>{UFunc.TglAngka(tanggal)}</td>
			<td className="px-1 text-start">
				<div>
					<b className="text-uppercase">{(terapi_main||"UNDF")}</b>
					<span> </span>
					<i>{(terapi_sub||"")}</i>
				</div>

				<div className="text-info text-capitalize"><small>{pasien_caption || ""}</small></div>
			</td>

			<td className="px-1 text-primary">{UFunc.formatAngka(tarif_terapi)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_lab)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_terukur)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_apd)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_charge)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_diskon)}</td>
			<td className="px-1">{UFunc.formatAngka(b_var_pajak)}</td>
			<td className="px-1">{UFunc.formatAngka(b_var_lain)}</td>
			<td className="px-1">{UFunc.formatAngka(b_dokter_diskon)}</td>

			<td className="px-1">
				<span className={parseFloat(nilai_fee_man||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_fee_man||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_fee_man)}
				<span className={parseFloat(nilai_fee_man||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(nilai_fee_klinik||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_fee_klinik||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_fee_klinik)}
				<span className={parseFloat(nilai_fee_klinik||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(nilai_fee_dokter||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_fee_dokter||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_fee_dokter)}
				<span className={parseFloat(nilai_fee_dokter||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			</tr>
			);
		})}
		</tbody>

		<tfoot>
		<tr className="fw-bolder bg-primary text-white align-top text-end">
			<td colSpan={2} className="px-1 text-center bg-primary text-uppercase" style={{...vStylekolfixed,minWidth:160}}>{uBahasaObj.word_jumlah||"JUMLAH"}</td>

			<td className="px-1"/>

			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.tarif_terapi))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_lab))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_terukur))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_apd))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_charge))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_diskon))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_var_pajak))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_var_lain))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_dokter_diskon))}
			</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumObj.nilai_fee_man||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_man))}
				<span className={parseFloat(uDatasumObj.nilai_fee_man||"0")>=0 ? "d-none":""}>)</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumObj.nilai_fee_klinik||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_klinik))}
				<span className={parseFloat(uDatasumObj.nilai_fee_klinik||"0")>=0 ? "d-none":""}>)</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumObj.nilai_fee_dokter||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_dokter))}
				<span className={parseFloat(uDatasumObj.nilai_fee_dokter||"0")>=0 ? "d-none":""}>)</span>
			</td>
		</tr>
		</tfoot>
		</table>
		</div>
		)//>
	}
	const contentTahunall = () => {
		if(uFilterObj.jenis !== "TAHUN") return ""
		if(parseInt(uFilterObj.terapimain_id||"0") > 0) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);

		const vDatamainArr	= uDatamainArr.slice(vMin,(vMax));

		const vWidthtabel	= 1700;

		const vStylekolfixed = {
			position: "sticky",
			left: 0,
			background: "#f0f0f0",
			zIndex: 1,
			borderRight:"1px solid #DCDCDC",
		}

		return (
		<div style={{overflowX:"auto"}} id="iddivtabel">
		<table style={{minWidth:vWidthtabel,width:"100%"}}
			className="table table-borderless table-striped table-hover"
			id="idtabeldata">
		<thead>
			<tr className="align-top text-center classfontsmaller">
			<th width={35} style={vStylekolfixed} className="px-1 border"><small>No</small></th>
			<th style={{...vStylekolfixed,left:35,minWidth:200}} className="px-1 text-start border"><small>{uBahasaObj.word_bulan||"Bulan"}</small></th>
			<th width={100} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="tarif_terapi" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_totalterapi||"Tot.Terapi"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("tarif_terapi")}>
				<CIcon icon={((uSortedObj.nama||"")==="tarif_terapi" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>

			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_lab" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_blab||"B.Lab"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_lab")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_lab" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_terukur" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bterukur||"B.Terukur"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_terukur")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_terukur" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_apd" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bapd||"B.APD"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_apd")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_apd" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_charge" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bcharge||"B.Charge"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_charge")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_charge" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_fxd_diskon" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_progdiskon||"Prog.Diskon"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_fxd_diskon")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_fxd_diskon" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_var_pajak" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bpajak||"B.Pajak"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_var_pajak")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_var_pajak" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_var_lain" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_blain||"B.Lain2"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_var_lain")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_var_lain" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="b_dokter_diskon" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_bdiskondokter||"Diskon Dokter"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("b_dokter_diskon")}>
				<CIcon icon={((uSortedObj.nama||"")==="b_dokter_diskon" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="nilai_fee_man" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_feemanajemen||"Fee Manajemen"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("nilai_fee_man")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_fee_man" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="nilai_fee_klinik" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_feeklinik||"Fee Klinik"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("nilai_fee_klinik")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_fee_klinik" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			<th width={99} className="px-1 border">
				<div className={"d-flex justify-content-between"+((uSortedObj.nama||"")==="nilai_fee_dokter" ? " text-danger" : "")}>
				<small className="w-100">{uBahasaObj.caption_feedokter||"Fee Dokter"} (Rp)</small>

				<CLink className="classcursorpointer" style={{color:"inherit"}}
					onClick={()=>hdlKlikSort("nilai_fee_dokter")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_fee_dokter" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={18}/>
				</CLink>
				</div>
			</th>
			</tr>
		</thead>

		<tbody>
		{vDatamainArr.map((vItems,vKeys)=>{
			const {
				bulan_caption,tarif_terapi,
				b_fxd_lab,b_fxd_terukur,b_fxd_apd,b_fxd_charge,
				b_fxd_diskon,b_var_pajak,b_var_lain,b_dokter_diskon,
				nilai_fee_man,nilai_fee_klinik,nilai_fee_dokter,
			} = vItems;

			vNumber++;
			return (
			<tr key={vKeys} className="align-top text-end">
			<td className="px-1" style={vStylekolfixed}>{vNumber}.</td>
			<td className="px-1 text-start" style={{...vStylekolfixed,left:35,minWidth:250}}>{(bulan_caption||"UNDF")}</td>
			<td className="px-1 text-primary">{UFunc.formatAngka(tarif_terapi)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_lab)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_terukur)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_apd)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_charge)}</td>
			<td className="px-1">{UFunc.formatAngka(b_fxd_diskon)}</td>
			<td className="px-1">{UFunc.formatAngka(b_var_pajak)}</td>
			<td className="px-1">{UFunc.formatAngka(b_var_lain)}</td>
			<td className="px-1">{UFunc.formatAngka(b_dokter_diskon)}</td>

			<td className="px-1">
				<span className={parseFloat(nilai_fee_man||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_fee_man||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_fee_man)}
				<span className={parseFloat(nilai_fee_man||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(nilai_fee_klinik||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_fee_klinik||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_fee_klinik)}
				<span className={parseFloat(nilai_fee_klinik||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(nilai_fee_dokter||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_fee_dokter||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_fee_dokter)}
				<span className={parseFloat(nilai_fee_dokter||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			</tr>
			);
		})}
		</tbody>

		<tfoot>
		<tr className="align-top text-end fw-bolder bg-primary text-white">
			<td colSpan={2} className="px-1 text-center bg-primary text-uppercase" style={{...vStylekolfixed,minWidth:250}}>{uBahasaObj.word_jumlah||"JUMLAH"}</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.tarif_terapi))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_lab))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_terukur))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_apd))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_charge))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_fxd_diskon))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_var_pajak))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_var_lain))}
			</td>
			<td className="px-1">
				{UFunc.formatAngka(Math.abs(uDatasumObj.b_dokter_diskon))}
			</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumObj.nilai_fee_man||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_man))}
				<span className={parseFloat(uDatasumObj.nilai_fee_man||"0")>=0 ? "d-none":""}>)</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumObj.nilai_fee_klinik||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_klinik))}
				<span className={parseFloat(uDatasumObj.nilai_fee_klinik||"0")>=0 ? "d-none":""}>)</span>
			</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumObj.nilai_fee_dokter||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_dokter))}
				<span className={parseFloat(uDatasumObj.nilai_fee_dokter||"0")>=0 ? "d-none":""}>)</span>
			</td>
		</tr>
		</tfoot>
		</table>
		</div>
		)//>
	}
	const _contentTahunall_ = () => {//--TIDAK_DIPAKAI--/
		if(uFilterObj.jenis !== "TAHUN") return ""
		if(parseInt(uFilterObj.terapimain_id||"0") > 0) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);

		const vDatamainArr	= uDatamainArr.slice(vMin,(vMax));

		const vKolwidth		= Math.round(83/13);
		const vNolArr		= [0,0,0,0,0,0,0,0,0,0,0,0,0];
		const vTotalArr		= uDatasumObj.nilai_arr || vNolArr;

		const vWidthno		= 40;
		const vWidthFirstkol= 250;
		const vWidthkolnilai= 100;

		const vWidthtabel	= vWidthno+vWidthFirstkol+(vWidthkolnilai*13) + 100;

		const vStylekolfixed = {
			position: "sticky",
			left: 0,
			background: "#f0f0f0",
			zIndex: 1,
			borderRight:"1px solid #DCDCDC",
		}

		return (
		<div style={{overflowX:"auto"}} id="iddivtabel">
		<table style={{minWidth:vWidthtabel,width:"100%"}}
			className="table table-borderless table-striped table-hover"
			id="idtabeldata">
		<thead>
			<tr className="align-top text-center classfontsmaller">
			<th width={vWidthno} style={vStylekolfixed} className="px-1 border">No</th>
			<th style={{...vStylekolfixed,left:vWidthno}} className="px-1 text-start border">{uBahasaObj.word_terapi||"Terapi"}</th>
			{cBulanPendek.map((vItems,vKeys)=>{
				return (<th width={vWidthkolnilai} key={vKeys} className="px-1 border">{vItems}</th>)
			})}
			<th width={vWidthkolnilai} className="px-1 border">
				<span className={"me-1"+((uSortedObj.nama||"")==="nilai_total" ? " text-danger" : "")}>
				{uBahasaObj.word_total||"Total"}
				</span>
				<CLink className={"classcursorpointer"}
					onClick={()=>hdlKlikSort("nilai_total")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_total" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={20}/>
				</CLink>
			</th>
			</tr>
		</thead>
		<tbody>
		{vDatamainArr.map((vItems,vKeys)=>{
			const {
				terapi_caption,id
			} = vItems;

			vNumber++;

			return (
			<tr id={"idtr"+vKeys} className="align-top text-end" key={vKeys}>
			<td style={vStylekolfixed} className="px-1">
				<small>{vNumber}.</small>
			</td>
			<td style={{...vStylekolfixed,left:vWidthno}} className="px-1 text-start">
				<small>{terapi_caption||"UNDF"}</small>
			</td>
			{cBulanPendek.map((vItemnilai,vKeynilai)=>{
				return (
				<td className="px-1" key={vKeynilai}>
				<small>{UFunc.formatAngka(vItems["nilai_"+UFunc.leadZero(vKeynilai)])}</small>
				</td>
				)
			})}
			<td className="px-1 text-primary">
				<small>{UFunc.formatAngka(vItems["nilai_total"])}</small>
			</td>
			</tr>
			)
		})}
		</tbody>

		<tfoot>
		<tr className="fw-bolder bg-primary text-white bg-primary text-end">
		<td colSpan={2} className="px-1 text-center bg-primary" style={vStylekolfixed}>JUMLAH</td>
		{vTotalArr.map((vItems,vKeys)=>{
			return (<td className="px-1" key={vKeys}>{UFunc.formatAngka(vItems)}</td>)
		})}
		</tr>
		</tfoot>
		</table>
		</div>
		)//>
	}
	const contentTahunterapi = () => {//--TIDAK_DIPAKAI--/
		if(uFilterObj.jenis !== "TAHUN") return ""
		if(parseInt(uFilterObj.terapimain_id||"0") <= 0) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= isMobile ? 0 : (vMin);

		const vDatamainArr	= isMobile 
			? uDatamainArr.slice(0,(vMax)) : uDatamainArr.slice(vMin,(vMax));

		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none"><th colSpan={2}>{vMin} - {vMax}</th></tr>
			<tr className="d-none d-md-table-row text-center">
			<th width="5%" className="align-top px-0 classfontsmaller">No</th>

			<th className="align-top px-0 classfontsmaller">
			<CRow className="mx-0">
			<CCol md="4" className="text-start">{uBahasaObj.word_bulan||"Bulan"}</CCol>
			<CCol md="2" className="px-0">
				<span className={"me-1"+((uSortedObj.nama||"")==="nilai_bruto" ? " text-danger" : "")}>
				{uBahasaObj.caption_feebruto||"Fee Bruto"} (Rp)
				</span>
				<CLink className={"classcursorpointer"}
					onClick={()=>hdlKlikSort("nilai_bruto")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_bruto" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={20}/>
				</CLink>
			</CCol>
			<CCol md="2" className="px-0">Pot.Diskon (Rp)</CCol>
			<CCol md="2" className="px-0">Pot.Payment (Rp)</CCol>
			<CCol md="2" className="px-0">
				<span className={"me-1"+((uSortedObj.nama||"")==="tarif_terapi" ? " text-danger" : "")}>
				{uBahasaObj.caption_feenetto||"Total Fee"} (Rp)
				</span>
				<CLink className={"classcursorpointer"}
					onClick={()=>hdlKlikSort("tarif_terapi")}>
				<CIcon icon={((uSortedObj.nama||"")==="tarif_terapi" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={20}/>
				</CLink>
			</CCol>
			</CRow>
			</th>
			</tr>
		</thead>

		<tbody>
		{vDatamainArr.map((vItems,vKeys)=>{
			const {
				bulan_caption,nilai_bruto,nilai_diskon,nilai_payment,
				tarif_terapi,
			} = vItems;

			vNumber++;
			return (
			<tr key={vKeys}>
			<td className="align-top text-end">{vNumber}.</td>
			
			<td className="align-top text-end">
				<CRow className="mx-0">
				<CCol md="4" className="px-1 text-md-start">{(bulan_caption||"UNDF")}</CCol>
				<CCol md="2" className="px-1 text-success">{UFunc.formatAngka(nilai_bruto||"0")}</CCol>
				<CCol md="2" className="px-1 text-danger">{UFunc.formatAngka(nilai_diskon||"0")}</CCol>
				<CCol md="2" className="px-1 text-danger">{UFunc.formatAngka(nilai_payment||"0")}</CCol>
				<CCol md="2" className="px-1">
				<span className={parseFloat(tarif_terapi||"0")>=0 ? "text-primary":"text-danger"}>
				<span className={parseFloat(tarif_terapi||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(tarif_terapi)}
				<span className={parseFloat(tarif_terapi||"0")>=0 ? "d-none":""}>)</span>
				</span>
				</CCol>
				</CRow>
			</td>
			</tr>
			);
		})}
		</tbody>

		<tfoot className="fw-bolder bg-primary text-white">
		<tr>
		<td className="align-top text-end">&nbsp;</td>
		<td className="text-end">
		<CRow className="mx-0">
			<CCol md="4" className="text-start text-uppercase">{uBahasaObj.word_jumlah||"JUMLAH"}</CCol>
			<CCol md="2" className="px-0">{UFunc.formatAngka(Math.abs(uDatasumObj.nilai_bruto))}</CCol>
			<CCol md="4"/>
			<CCol md="2" className="px-0">
				<span className={parseFloat(uDatasumObj.tarif_terapi||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumObj.tarif_terapi))}
				<span className={parseFloat(uDatasumObj.tarif_terapi||"0")>=0 ? "d-none":""}>)</span>
			</CCol>
		</CRow>
		</td>
		</tr>
		</tfoot>
		</table>
		)//>
	}
	const contentCetak = () => {
		if(uDatamainArr.length <= 0) return "";
		//console.log("(Lapterapi - contentCetak) vHTMLs => "+vHTMLs)

		if(uFilterObj.jenis==="TAHUN") {
			return cetakTahunall();
		}
		if(uFilterObj.jenis==="BULAN") {
			if(parseInt(uFilterObj.terapimain_id||"0") > 0)
				return cetakBulanterapi();
			return cetakBulanall();
		}
		if(uFilterObj.jenis==="TANGGAL") {
			return cetakTanggalall();
		}

		return (<></>)//>
	}
	const cetakTanggalall = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		
		const vTerapitext	= "SEMUA TERAPI";

		let vHTMLs 	= uHTMLstylelaporan;
		vHTMLs += `
			<table id="idtabelhtml">
			<thead>
			<tr>
			<td colspan="15">
			<div><b>`+(uBahasaObj["menus_"+uActiveroute.toLowerCase()]||"Laporan").toUpperCase()+`</b></div>
			<div>`+uCaptionObj.title+`</div>`+
			(uDatacabangArr.length > 1 ? `<div>Cabang: `+vCabangtext+` - `+vTerapitext+`</div>`
				: `<div>`+vTerapitext+`</div>`)+
			`</td>
			</tr>
			<tr class="idtabelheader">
				<th width="3%"><small>No</small></th>
				<th align="left"><small>`+(uBahasaObj.word_terapi||"Terapi")+`</small></th>
				<th align="left" width="13%"><small>`+(uBahasaObj.word_pasien||"Pasien")+`</small></th>
				<th width="11%"><small>`+(uBahasaObj.caption_tarifterapi||"N.Terapi")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_blab||"B.Lab")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bterukur||"B.Terukur")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bapd||"B.APD")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bcharge||"B.Charge")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_potdiskon||"Prog.Diskon")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bpajak||"B.Pajak")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_blain||"B.Lain")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bdiskondokter||"Disc.Diskon")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_feemanajemen||"Fee Man")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_feeklinik||"Fee Klinik")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_feedokter||"Fee Dokter")+` (Rp)</small></th>
			</tr>
			</thead>
			<tbody>`;
		vHTMLs 	+= uDatamainArr.map((vItems,vKeys)=>{
			const {
				pasien_caption,terapi_caption,tarif_terapi,
				terapi_main,terapi_sub,
				b_fxd_lab,b_fxd_terukur,b_fxd_apd,b_fxd_charge,
				b_fxd_diskon,b_var_pajak,b_var_lain,b_dokter_diskon,
				nilai_fee_man,nilai_fee_klinik,nilai_fee_dokter,
			} = vItems;

			return (`
			<tr key="`+vKeys+`" valign="top">
				<td align="right" style="font-size:smaller">`+(vKeys+1)+`.</td>
				<td align="left"><small>`+
					(terapi_main||"UNDF")+
					` <i>`+(terapi_sub||"UNDF")+`</i>`+
				`</small></td>
				<td align="left"><small>`+(pasien_caption||"UNDF")+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(tarif_terapi)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_lab)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_terukur)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_apd)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_charge)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_diskon)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(b_var_pajak)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(b_var_lain)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(b_dokter_diskon)+`</small></td>
				<td align="right"><small>`+
				(parseFloat(nilai_fee_man||"0") >= 0 ? UFunc.formatAngka(nilai_fee_man)
					: "("+UFunc.formatAngka(Math.abs(nilai_fee_man))+")"
					)+
				`</small></td>
				<td align="right"><small>`+
				(parseFloat(nilai_fee_klinik||"0") >= 0 ? UFunc.formatAngka(nilai_fee_klinik)
					: "("+UFunc.formatAngka(Math.abs(nilai_fee_klinik))+")"
					)+
				`</small></td>
				<td align="right"><small>`+
				(parseFloat(nilai_fee_dokter||"0") >= 0 ? UFunc.formatAngka(nilai_fee_dokter)
					: "("+UFunc.formatAngka(Math.abs(nilai_fee_dokter))+")"
					)+
				`</small></td>
			</tr>
			`);
		}).join(``);

		vHTMLs += `
			</tbody>
			<tfoot>
			<tr>
				<td colspan="3" align="center"><small>JUMLAH</small></td>
				<td align="right"><small>`+UFunc.formatAngka(uDatasumObj.tarif_terapi)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(uDatasumObj.b_fxd_lab)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(uDatasumObj.b_fxd_terukur)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(uDatasumObj.b_fxd_apd)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(uDatasumObj.b_fxd_charge)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(uDatasumObj.b_fxd_diskon)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(uDatasumObj.b_var_pajak)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(uDatasumObj.b_var_lain)+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(uDatasumObj.b_dokter_diskon)+`</small></td>
				<td align="right"><small>`+
				(parseFloat(uDatasumObj.nilai_fee_man) >= 0 
					? UFunc.formatAngka(uDatasumObj.nilai_fee_man) 
					: "("+UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_man))+")")+
				`</small></td>
				<td align="right"><small>`+
				(parseFloat(uDatasumObj.nilai_fee_klinik) >= 0 
					? UFunc.formatAngka(uDatasumObj.nilai_fee_klinik) 
					: "("+UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_klinik))+")")+
				`</small></td>
				<td align="right"><small>`+
				(parseFloat(uDatasumObj.nilai_fee_dokter) >= 0 
					? UFunc.formatAngka(uDatasumObj.nilai_fee_dokter) 
					: "("+UFunc.formatAngka(Math.abs(uDatasumObj.nilai_fee_dokter))+")")+
				`</small></td>
			</tr>
			</tfoot>
			</table>
		`;

		return vHTMLs;
	}
	const cetakBulanall = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		
		const vTerapitext	= "SEMUA TERAPI";

		let vHTMLs 	= uHTMLstylelaporan;
		vHTMLs += `
			<table id="idtabelhtml">
			<thead>
			<tr>
			<td colspan="14">
			<div><b>`+(uBahasaObj["menus_"+uActiveroute.toLowerCase()]||"Laporan").toUpperCase()+`</b></div>
			<div>`+uCaptionObj.title+`</div>`+
			(uDatacabangArr.length > 1 ? `<div>Cabang: `+vCabangtext+` - `+vTerapitext+`</div>`
				: `<div>`+vTerapitext+`</div>`)+
			`</td>
			</tr>
			<tr class="idtabelheader">
				<th width="3%"><small>No</small></th>
				<th align="left"><small>`+(uBahasaObj.word_terapi||"Terapi")+`</small></th>
				<th width="10%"><small>`+(uBahasaObj.caption_nilaiterapi||"N.Terapi")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_blab||"B.Lab")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bterukur||"B.Terukur")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bapd||"B.APD")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bcharge||"B.Charge")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_potdiskon||"Prog.Diskon")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bpajak||"B.Pajak")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_blain||"B.Lain2")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bdiskondokter||"Disc.Dokter")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_feemanajemen||"Fee Man")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_feeklinik||"Fee Klinik")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_feedokter||"Fee Dokter")+` (Rp)</small></th>
			</tr>
			</thead>
			<tbody>`;

		vHTMLs 	+= uDatamainArr.map((vItems,vKeys)=>{
			const {
				terapi_caption,terapi_main,tarif_terapi,
				b_fxd_lab,b_fxd_terukur,b_fxd_apd,b_fxd_charge,
				b_fxd_diskon,b_var_pajak,b_var_lain,b_dokter_diskon,
				nilai_fee_man,nilai_fee_klinik,nilai_fee_dokter,
			} = vItems;

			return (`
			<tr key="`+vKeys+`" valign="top">
				<td align="right" style="font-size:smaller">`+(vKeys+1)+`.</td>
				<td align="left"><small>`+(terapi_caption||"UNDF")+`</small></td>
				<td align="right"><small>`+UFunc.formatAngka(tarif_terapi)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_lab)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_terukur)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_apd)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_charge)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_diskon)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_var_pajak)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_var_lain)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_dokter_diskon)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(nilai_fee_man)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(nilai_fee_klinik)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(nilai_fee_dokter)+`</td>
			</tr>
			`);
		}).join(``);

		vHTMLs += `
			</tbody>
			<tfoot>
			<tr>
			<td colspan="2" align="center">JUMLAH</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.tarif_terapi)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_lab)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_terukur)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_apd)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_charge)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_diskon)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_var_pajak)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_var_lain)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_dokter_diskon)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.nilai_fee_man)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.nilai_fee_klinik)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.nilai_fee_dokter)+`</td>
			</tr>
			</tfoot>
			</table>
		`;

		return vHTMLs;
	}
	const cetakBulanterapi = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		
		const vTerapiIdx	= UFunc.getObjectIndeks(uTerapimainArr,uFilterObj.terapimain_id);
		const vTerapitext	= uTerapimainArr[vTerapiIdx].nama_terapi;

		let vHTMLs 	= uHTMLstylelaporan;
		vHTMLs += `
			<table id="idtabelhtml">
			<thead>
			<tr>
			<td colspan="14">
			<div><b>`+(uBahasaObj["menus_"+uActiveroute.toLowerCase()]||"Laporan").toUpperCase()+`</b></div>
			<div>`+uCaptionObj.title+`</div>`+
			(uDatacabangArr.length > 1 ? `<div>Cabang: `+vCabangtext+` - `+vTerapitext+`</div>`
				: `<div>`+vTerapitext+`</div>`)+
			`</td>
			</tr>
			<tr class="idtabelheader">
				<th width="3%"><small>No</small></th>
				<th width="10%"><small>`+(uBahasaObj.word_tanggal||"Tanggal")+`</small></th>
				<th align="left"><small>`+(uBahasaObj.word_terapi||"Terapi")+`</small></th>
				<th width="10%"><small>`+(uBahasaObj.caption_nilaiterapi||"N.Terapi")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_blab||"B.Lab")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bterukur||"B.Terukur")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bapd||"B.APD")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bcharge||"B.Charge")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_potdiskon||"Prog.Diskon")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bpajak||"B.Pajak")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_blain||"B.Lain2")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bdiskondokter||"Disc.Dokter")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_feemanajemen||"Fee Man")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_feeklinik||"Fee Klinik")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_feedokter||"Fee Dokter")+` (Rp)</small></th>
			</tr>
			</thead>
			<tbody>`;

		vHTMLs 	+= uDatamainArr.map((vItems,vKeys)=>{
			const {
				pasien_caption,tanggal,terapi_sub,terapi_main,tarif_terapi,
				b_fxd_lab,b_fxd_terukur,b_fxd_apd,b_fxd_charge,
				b_fxd_diskon,b_var_pajak,b_var_lain,b_dokter_diskon,
				nilai_fee_man,nilai_fee_klinik,nilai_fee_dokter,
			} = vItems;

			return (`
			<tr key="`+vKeys+`" valign="top">
				<td align="right" style="font-size:smaller">`+(vKeys+1)+`.</td>
				<td align="center"><small>`+UFunc.TglAngka(tanggal)+`</small></td>
				
				<td align="left"><small>
					<div style="font-weight:bolder;">
						`+(terapi_main||"UNDF")+`<span> </span>
						<i>`+(terapi_sub||"UNDF")+`</i>
						</div>
					<div style="font-style:italic;">`+(pasien_caption||"UNDF")+`</div>
				</small>
				</td>
				
				<td align="right"><small>`+UFunc.formatAngka(tarif_terapi)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_lab)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_terukur)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_apd)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_charge)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_diskon)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_var_pajak)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_var_lain)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_dokter_diskon)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(nilai_fee_man)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(nilai_fee_klinik)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(nilai_fee_dokter)+`</td>
			</tr>
			`);
		}).join(``);

		vHTMLs += `
			</tbody>
			<tfoot>
			<tr>
			<td colspan="3" align="center">JUMLAH</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.tarif_terapi)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_lab)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_terukur)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_apd)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_charge)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_diskon)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_var_pajak)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_var_lain)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_dokter_diskon)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.nilai_fee_man)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.nilai_fee_klinik)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.nilai_fee_dokter)+`</td>
			</tr>
			</tfoot>
			</table>
		`;

		return vHTMLs;
	}
	const cetakTahunall = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";

		const vTerapitext	= "SEMUA TERAPI";
		let vHTMLs 	= uHTMLstylelaporan;
		vHTMLs += `
			<table id="idtabelhtml">
			<thead>
			<tr>
			<td colspan="14">
			<div><b>`+(uBahasaObj["menus_"+uActiveroute.toLowerCase()]||"Laporan").toUpperCase()+`</b></div>
			<div>`+uCaptionObj.title+`</div>`+
			(uDatacabangArr.length > 1 ? `<div>Cabang: `+vCabangtext+` - `+vTerapitext+`</div>`
				: `<div>`+vTerapitext+`</div>`)+
			`</td>
			</tr>
			<tr class="idtabelheader">
				<th width="5%">No</th>
				<th align="left">`+(uBahasaObj.word_bulan||"Bulan")+`</th>
				<th width="10%">`+(uBahasaObj.caption_totalterapi||"Tot.Terapi")+`</th>
				<th width="9%"><small>`+(uBahasaObj.caption_blab||"B.Lab")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bterukur||"B.Terukur")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bapd||"B.APD")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bcharge||"B.Charge")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_potdiskon||"Prog.Diskon")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bpajak||"B.Pajak")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_blain||"B.Lain2")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_bdiskondokter||"Disc.Dokter")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_feemanajemen||"Fee Man")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_feeklinik||"Fee Klinik")+` (Rp)</small></th>
				<th width="9%"><small>`+(uBahasaObj.caption_feedokter||"Fee Dokter")+` (Rp)</small></th>
			</tr>
			</thead>
			<tbody>`;

		vHTMLs += uDatamainArr.map((vItems,vKeys)=>{
			const {
				bulan_caption,id,tarif_terapi,
				b_fxd_lab,b_fxd_terukur,b_fxd_apd,b_fxd_charge,
				b_fxd_diskon,b_var_pajak,b_var_lain,b_dokter_diskon,
				nilai_fee_man,nilai_fee_klinik,nilai_fee_dokter,
			} = vItems;

			return (`
			<tr key={vKeys} valign="top">
				<td align="right" style="font-size:smaller">`+(vKeys+1)+`.</td>
				<td align="left">`+(bulan_caption||"UNDF")+`</td>
				<td align="right"><small>`+UFunc.formatAngka(tarif_terapi)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_lab)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_terukur)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_apd)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_charge)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_fxd_diskon)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_var_pajak)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_var_lain)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(b_dokter_diskon)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(nilai_fee_man)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(nilai_fee_klinik)+`</td>
				<td align="right"><small>`+UFunc.formatAngka(nilai_fee_dokter)+`</td>
			</tr>
			`);
		}).join(``);

		vHTMLs += `
			</tbody>
			<tfoot>
			<tr>
			<td colspan="2" align="center">JUMLAH</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.tarif_terapi)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_lab)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_terukur)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_apd)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_charge)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_fxd_diskon)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_var_pajak)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_var_lain)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.b_dokter_diskon)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.nilai_fee_man)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.nilai_fee_klinik)+`</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.nilai_fee_dokter)+`</td>
			</tr>
			</tfoot>
			</table>
		`;

		return vHTMLs;
	}
	const _cetakTahunall_ = () => {//--TIDAK_DIPAKAI--/
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		const vKolwidth		= Math.round(75/13);

		const vTerapitext	= "SEMUA TERAPI";
		let vHTMLs 	= uHTMLstylelaporan;
		vHTMLs += `
			<table id="idtabelhtml">
			<thead>
			<tr>
			<td colspan="15">
			<div><b>`+(uBahasaObj["menus_"+uActiveroute.toLowerCase()]||"Laporan").toUpperCase()+`</b></div>
			<div>`+uCaptionObj.title+`</div>`+
			(uDatacabangArr.length > 1 ? `<div>Cabang: `+vCabangtext+` - `+vTerapitext+`</div>`
				: `<div>`+vTerapitext+`</div>`)+
			`</td>
			</tr>
			<tr class="idtabelheader">
				<th width="5%">No</th>
				<th align="left">`+(uBahasaObj.word_terapi||"Terapi")+`</th>`+
				(cBulanPendek.map(vItems=>{
					return (`<th width="`+vKolwidth+`%">`+vItems+`</th>`)
				}).join(""))+
				`<th width="`+vKolwidth+`%">`+(uBahasaObj.word_total||"Total")+`</th>
			</tr>
			</thead>
			<tbody>`;
		uDatamainArr.forEach((vItems,vKeys)=>{
			const {
				terapi_caption,id
			} = vItems;

			vHTMLs 	+= `
			<tr key={vKeys} valign="top">
				<td align="right" style="font-size:smaller">`+(vKeys+1)+`.</td>
				<td align="left">`+(terapi_caption||"UNDF")+`</td>`+
				(cBulanPendek.map((vItembulan,vKeybulan)=>{
					return (`<td align="right">`+UFunc.formatAngka(vItems["nilai_"+UFunc.leadZero(vKeybulan)])+`</td>`)
				}).join(""))+
				`<td align="right">`+
				(parseFloat(vItems["nilai_total"]||"0") >= 0 
					? UFunc.formatAngka(vItems["nilai_total"])
					: "("+UFunc.formatAngka(Math.abs(vItems["nilai_total"]))+")"
				)+
				`</td>
			</tr>
			`;
		});

		const vNolArr		= [0,0,0,0,0,0,0,0,0,0,0,0,0];
		const vTotalArr		= uDatasumObj.nilai_arr || vNolArr;
		vHTMLs += `
			</tbody>
			<tfoot>
			<tr>
			<td colspan="2" align="center">JUMLAH</td>`+
			(vTotalArr.map(vItems=>{
				return (
				`<td align="right">`+
				(parseFloat(vItems||"0") >= 0 
					? UFunc.formatAngka(vItems) 
					: "("+UFunc.formatAngka(Math.abs(vItems))+")")+
				`</td>`
				)
			})).join("")+
			`</td>
			</tr>
			</tfoot>
			</table>
		`;

		return vHTMLs;
	}
	const cetakTahunterapi = () => {//--TIDAK_DIPAKAI--/
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		
		const vTerapiIdx	= UFunc.getObjectIndeks(uTerapimainArr,uFilterObj.terapimain_id);
		const vTerapitext	= uTerapimainArr[vTerapiIdx].nama_terapi;

		let vHTMLs 	= uHTMLstylelaporan;
		vHTMLs += `
			<table id="idtabelhtml">
			<thead>
			<tr>
			<td colspan="6">
			<div><b>`+(uBahasaObj["menus_"+uActiveroute.toLowerCase()]||"Laporan").toUpperCase()+`</b></div>
			<div>`+uCaptionObj.title+`</div>`+
			(uDatacabangArr.length > 0 ? `<div>Cabang: `+vCabangtext+` - `+vTerapitext+`</div>`
				: `<div>`+vTerapitext+`</div>`)+
			`</td>
			</tr>
			<tr class="idtabelheader" valign="top">
				<th width="5%">No</th>
				<th align="left">`+(uBahasaObj.word_bulan||"Bulan")+`</th>
				<th width="15%">`+(uBahasaObj.caption_feebruto||"Fee Bruto")+` (Rp)</th>
				<th width="13%">`+(uBahasaObj.caption_potdiskon||"Pot.Diskon")+` (Rp)</th>
				<th width="13%">`+(uBahasaObj.caption_potpayment||"Pot.Payment")+` (Rp)</th>
				<th width="20%">`+(uBahasaObj.caption_feenetto||"Total Fee")+` (Rp)</th>
			</tr>
			</thead>
			<tbody>`;
		uDatamainArr.forEach((vItems,vKeys)=>{
			const {
				bulan_caption,nilai_bruto,nilai_diskon,nilai_payment,tarif_terapi
			} = vItems;

			vHTMLs 	+= `
			<tr key={vKeys} valign="top">
				<td align="right" style="font-size:smaller">`+(vKeys+1)+`.</td>
				<td align="left">`+(bulan_caption||"UNDF")+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_bruto)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_diskon)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_payment)+`</td>
				<td align="right">`+
				(parseFloat(tarif_terapi||"0") >= 0 ? UFunc.formatAngka(tarif_terapi)
					: "("+UFunc.formatAngka(Math.abs(tarif_terapi))+")"
					)+
				`</td>
			</tr>
			`;
		});
		vHTMLs += `
			</tbody>
			<tfoot>
			<tr>
			<td colspan="2" align="center">JUMLAH</td>
			<td align="right">`+UFunc.formatAngka(uDatasumObj.nilai_bruto)+`</td>
			<td colspan="2" align="center">&nbsp;</td>
			<td align="right">`+
				(parseFloat(uDatasumObj.tarif_terapi) >= 0 
					? UFunc.formatAngka(uDatasumObj.tarif_terapi) 
					: "("+UFunc.formatAngka(Math.abs(uDatasumObj.tarif_terapi))+")")+
			`</td>
			</tr>
			</tfoot>
			</table>
		`;

		return vHTMLs;
	}
	//--END CONTENT--/

	//--REST_API--/
	const apiLoadawal = () => {
		setHtml500msg();
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Lapterapi - apiLoadawal) LEWaT "); 
		let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); },2500); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_lapterapi/ld_init";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				setTerapimainArr(JSON.parse(output_string.dataterapimain||"[]"));
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapterapi - apiLoadawal) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<font color='red'>"+vMsg+"</font>");
			} else if(output_string.expired) {
				setDlgformshow(false); setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Lapterapi - apiLoadawal) catch-error : "+error);
			//showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoaddata = () => {
		uElBtnsimpan && (uElBtnsimpan.disabled = true)
		setLoading(true);
		const vTmpFilterObj 		= uFormdataObj;
		vTmpFilterObj.init_change 	= undefined;

		/*//--TESTING_FRONTEND--/
		let vTmpObj	= []
		let vTimeout = setTimeout(()=>{
		},2500); return
		//--END TESTING_FRONTEND--*/

		let vApiurl	=  "";
		if(vTmpFilterObj.jenis==="TAHUN") {
			vApiurl = "ld_tahunall";
		} else if(vTmpFilterObj.jenis==="BULAN") {
			vApiurl = "ld_bulanall";
			if((parseInt(vTmpFilterObj.terapimain_id)||0) > 0)
				vApiurl = "ld_bulanterapi"
		} else {
			vApiurl = "ld_tanggalall";
		}
		const vDATAS	= JSON.stringify({
			send_filterlist : JSON.stringify(vTmpFilterObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_lapterapi/"+vApiurl;

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			uElBtnsimpan && (uElBtnsimpan.disabled = false)
			setLoading(false);
			if(output_string.tampil) {
				setFilterObj(vTmpFilterObj);
				const vLoadArr	= JSON.parse(output_string.dataobject||"[]");
				/*//--LOAD_PER_PAGE--/
				vLoadArr.map(vItems=>vItems.pg = parseInt(_PAGE)||1);
				setDatamainArr([...vDatamainArr,...vLoadArr]);
				setJmlData(parseInt(output_string.totaldata||uJmlData));
				//--END LOAD_PER_PAGE--*/

				//--LOAD_ALL_VIEW_PER_PAGE--/
				//console.log("(Lapterapi - apiLoaddata) vLoadArr => "+JSON.stringify(vLoadArr));
				setDatamainArr(vLoadArr);
				//--END LOAD_ALL_VIEW_PER_PAGE--*/

				setFirstload("TIDAK");
				
				hdlToggleDlgform();
				setDataloaded(true);

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapterapi - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			uElBtnsimpan && (uElBtnsimpan.disabled = false)
			setLoading(false);
			console.log("(Lapterapi - apiLoaddata) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END REST_API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});
		
		apiLoadawal();

		return () => {
			setDlgformshow(false);
			setDatamainArr([]); setDataloaded(false); setTerapimainArr([])
		}
	},[])
	React.useEffect(()=>{ initJmldata() },[uElJmlData])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setPageActive(uPageActive<=0?1:uPageActive);

		initJmldata()
	},[uJmlData])
	React.useEffect(()=>{
		if(uDatamainArr.length <= 0)
			{ setDatadefaultArr([]); return }
		setDatadefaultArr([{init_change:"1"},...uDatamainArr]) 
	},[uDatamainArr])
	React.useEffect(()=>{
		setJmlData(uDatamainArr.length)
		if(uDatamainArr.length <= 0)
			{ setDatasumObj({}); return }

		const vSumkomponenObj = {
			tarif_terapi: uDatamainArr.reduce((vStores,vItems) => 
				vStores = vStores + parseFloat(vItems.tarif_terapi||"0")
				, 0),

			b_fxd_lab: uDatamainArr.reduce((vStores,vItems) => 
				vStores = vStores + parseFloat(vItems.b_fxd_lab||"0")
				, 0),
			b_fxd_terukur: uDatamainArr.reduce((vStores,vItems) => 
				vStores = vStores + parseFloat(vItems.b_fxd_terukur||"0")
				, 0),
			b_fxd_apd: uDatamainArr.reduce((vStores,vItems) => 
				vStores = vStores + parseFloat(vItems.b_fxd_apd||"0")
				, 0),
			b_fxd_charge: uDatamainArr.reduce((vStores,vItems) => 
				vStores = vStores + parseFloat(vItems.b_fxd_charge||"0")
				, 0),
			b_fxd_diskon: uDatamainArr.reduce((vStores,vItems) => 
				vStores = vStores + parseFloat(vItems.b_fxd_diskon||"0")
				, 0),
			b_var_pajak: uDatamainArr.reduce((vStores,vItems) => 
				vStores = vStores + parseFloat(vItems.b_var_pajak||"0")
				, 0),
			b_var_lain: uDatamainArr.reduce((vStores,vItems) => 
				vStores = vStores + parseFloat(vItems.b_var_lain||"0")
				, 0),
			b_dokter_diskon: uDatamainArr.reduce((vStores,vItems) => 
				vStores = vStores + parseFloat(vItems.b_dokter_diskon||"0")
				, 0),
			nilai_fee_man: uDatamainArr.reduce((vStores,vItems) => 
				vStores = vStores + parseFloat(vItems.nilai_fee_man||"0")
				, 0),
			nilai_fee_klinik: uDatamainArr.reduce((vStores,vItems) => 
				vStores = vStores + parseFloat(vItems.nilai_fee_klinik||"0")
				, 0),
			nilai_fee_dokter: uDatamainArr.reduce((vStores,vItems) => 
				vStores = vStores + parseFloat(vItems.nilai_fee_dokter||"0")
				, 0),
		}
		setDatasumObj({
			...vSumkomponenObj,
		});
	},[uDatamainArr,uDatamainArr.length])
	React.useEffect(()=>{
		/*//--LOAD_PER_PAGE--/
		if(uFirstload==="YA") return;

		setIDselect(0);
		setRowselect(-1);
		const vDatapageArr = uDatamainArr.filter(vItems=>parseInt(vItems.pg||0)===parseInt(uPageActive||1));
		if(vDatapageArr.length > 0) { 
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}

		apiLoaddata(uPageActive);
		//--END LOAD_PER_PAGE--*/

		//--LOAD_ALL_VIEW_PER_PAGE--/
		setIDselect(0);
		setRowselect(-1);
		//--END LOAD_ALL_VIEW_PER_PAGE--/
	},[uPageActive])//-->Unselect_ROW
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
		
		if(uHtml500msg) {
			return;
		}
		//console.log("(Lapterapi [uHandelView]) uHandelView => "+uHandelView)

		setHeaderDlgform("Pilih Filter Laporan")
		setFormdataObj({...uFilterObj, init_change: 1});
		setDlgformshow(true)
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelReset) return;

		uHeaderActionObj.isHeaderreset = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) { apiLoadawal(); }
		else { setDataloaded(false); }
	},[uHandelReset])
	React.useEffect(()=>{
		if(!uIsDataloaded)
			{ initResettampilan(); return; }

		//--SET_TITLE--/
		let vTitelmain	= "Periode ";
		if(uFormdataObj.jenis === "BULAN") {
			vTitelmain += "BULAN <b>"+cBulanPanjang[parseInt(uFormdataObj.bln)-1]+" "+uFormdataObj.thn+"</b>";
		} else if(uFormdataObj.jenis === "TAHUN") {
			vTitelmain += "Tahun <b>"+uFormdataObj.thn+"</b>";
		} else {
			vTitelmain += "Tanggal <b>"+
				uFormdataObj.tgl+"/"+
				uFormdataObj.bln+"/"+
				uFormdataObj.thn+
				"</b>";
		}

		const vCabangIdx= UFunc.getObjectIndeks(uDatacabangArr,uFormdataObj.cabang_id);
		let vTitelsub	= uDatacabangArr.length > 1 ? uDatacabangArr[vCabangIdx].cabang_nama+" &middot; " : "";
		if(parseInt(uFormdataObj.terapimain_id||"0") <= 0) 
			vTitelsub	+= "[SEMUA TERAPI]";
		else {
			const vTerapiIdx= UFunc.getObjectIndeks(uTerapimainArr,uFormdataObj.terapimain_id);
			vTitelsub	+= "<b>"+uTerapimainArr[vTerapiIdx].nama_terapi+"</b>";
		}

		//vTitelsub = "&middot; "+vTitelsub+" &middot;";
		setCaptionObj({title:vTitelmain,title_sub:vTitelsub});
		//--END SET_TITLE--/
	},[uIsDataloaded])
	React.useEffect(()=>{
		//console.log("(Lapterapi - [uIsDlgformshow]) uFilterObj => "+JSON.stringify(uFilterObj));
		if(!uIsDlgformshow) 
			{ setFormdataObj({}); return }

		//console.log("(Lapterapi - [uIsDlgformshow]) uFormdataObj => "+JSON.stringify(uFormdataObj));
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			const vButton = document.getElementById("btnDialogSimpan");
			vButton && (vButton.innerHTML = "Tampilkan");
			setElBtnsimpan(vButton);

			const vElfocus = document.getElementById("inpcabangid");
			vElfocus && vElfocus.focus();
		},350)
	},[uIsDlgformshow])
	React.useEffect(()=>{
		if(uFormdataObj.cabang_id === undefined)
			uFormdataObj.cabang_id = localStorage.getItem("lastcabangid") 
				|| (uDatacabangArr[0].id || "0");
		if(uFormdataObj.jenis === undefined)
			uFormdataObj.jenis = "TANGGAL";
		else {
			if(uFormdataObj.jenis !== "BULAN")
				uFormdataObj.terapimain_id = "0";
		}
		if(uFormdataObj.terapimain_id === undefined)
			uFormdataObj.terapimain_id = "0";

		const vTanggalNow	= new Date();
		if(uFormdataObj.tgl === undefined) //uFormdataObj.tgl="11";
			uFormdataObj.tgl = UFunc.leadZero(vTanggalNow.getDate());
		if(uFormdataObj.bln === undefined)
			uFormdataObj.bln = UFunc.leadZero(vTanggalNow.getMonth()+1);
		if(uFormdataObj.thn === undefined) //uFormdataObj.thn = "2021";
			uFormdataObj.thn = UFunc.leadZero(vTanggalNow.getFullYear());
	},[uFormdataObj,
	uFormdataObj.cabang_id,
	uFormdataObj.jenis,
	uFormdataObj.tgl,
	uFormdataObj.bln,
	uFormdataObj.thn,
	uFormdataObj.terapimain_id,
	])
	React.useEffect(()=>{
		if(uDatamainArr.length <= 0) return;
		if(uPageActive > 1) setPageActive(1);
		else 
			{ setRowselect(-1); setIDselect(0); }

		if(JSON.stringify(uSortedObj||{}) === "{}") { return; }

		//console.log("(Lapterapi - [uSortedObj]) uSortedObj => "+JSON.stringify(uSortedObj));
		//console.log("(Lapterapi - [uSortedObj]) uDatamainArr => "+JSON.stringify(uDatamainArr));

		let vSortedArr;
		const vNamasort	= (uSortedObj.nama||"").toLowerCase();
		const vISNumeric= UFunc.isNumeric(uDatamainArr[0][vNamasort]);
		if(uSortedObj.jenis === "ASCENDING") {
			vSortedArr	= !vISNumeric
				? uDatamainArr.sort((a, b) => {
					return (a[vNamasort] > b[vNamasort]) ? 1 : ((b[vNamasort] > a[vNamasort]) ? -1 : 0) 
					}) 
				: uDatamainArr.sort((a, b) => a[vNamasort] - b[vNamasort]) ;
		}else if(uSortedObj.jenis === "DESCENDING") {
			vSortedArr	= !vISNumeric
				? uDatamainArr.sort((a, b) => {
					return (b[vNamasort] > a[vNamasort]) ? 1 : ((a[vNamasort] > b[vNamasort]) ? -1 : 0) 
				})
				: uDatamainArr.sort((a, b) => b[vNamasort] - a[vNamasort]);
		} else {
			vSortedArr	= uDatadefaultArr.slice(1);//.splice(0,1);
		}
		//console.log("(Lapterapi - [uSortedObj]) vSortedArr => "+JSON.stringify(vSortedArr));
		setDatamainArr(vSortedArr);
		setEfekview(!uEfekview);
	},[uSortedObj,
	uSortedObj.nama,
	uSortedObj.jenis,
	])
	
	//console.log("(Lapterapi) uActiveroute => "+(uActiveroute));
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return; }
	if(uHtml500msg) return (
		<CCard className="classbgcard">
		<CCardHeader className="fw-bolder">Page 500</CCardHeader>
		<CCardBody className="mx-md-5 p-md-5">
		<div className="fst-italic">
		{UFunc.renderHTML(uHtml500msg)}
		</div>
		</CCardBody>
		</CCard>
	)//>

	return (
		<>
		{(!uIsDataloaded) ? (
		<CCard className="classbgcard">
			<CCardHeader className="fw-bolder">Pilih Filter Laporan</CCardHeader>
			<CCardBody className="mx-md-5 p-md-5">
			<div className="mx-lg-5 px-lg-5 fst-italic classpetunjuk">
			*) Silahkan Pilih Filter, untuk menentukan Parameter Laporan yang akan Ditampilkan. Kemudian Tekan SIMPAN. Untuk Mencetak Silahkan KLIK Ikon Cetak..
			</div>
			</CCardBody>
		</CCard>
		) : (
		<CCard className="classbgcard">
			<CCardHeader className="d-flex justify-content-between">
			<div>
				<div>{UFunc.renderHTML(uCaptionObj.title)}</div>
				<small>
					<small className="classfontsmaller text-primary">
					{UFunc.renderHTML(uCaptionObj.title_sub)}
					</small>
				</small>
			</div>

			<div>
			<span className="d-none d-md-inline">
				<CTooltip content="--CETAK..">
				<CLink 
					className="classikon classikoncetak classcursorpointer"
					onClick={()=>hdlKlikCetak()}/>
				</CTooltip>

				<CTooltip content="--Export-2-Excel..">
				<CLink 
					className="classikon classikonexcel classcursorpointer"
					onClick={()=>hdlKlikExcel()}/>
				</CTooltip>
			</span>

			<CDropdown className="d-md-none">
				<CDropdownToggle caret={false} size="sm"
					className="p-0" color="transparent">
					<CIcon icon="cilChevronBottom" className="classikonbox mx-1" height={25}/>
				</CDropdownToggle>
				<CDropdownMenu>
					<CDropdownItem onClick={()=>hdlKlikCetak()}>
						<CIcon className="classikoncetak ms-0 me-2 align-middle" height={25}/>
						Cetak Laporan
					</CDropdownItem>
					<CDropdownItem onClick={()=>hdlKlikExcel()}>
						<CIcon className="classikonexcel ms-0 me-2 align-middle" height={25}/>
						Export-2-Excel
					</CDropdownItem>
				</CDropdownMenu>
			</CDropdown>

			<span className="mx-1">&middot;</span>
			<span className="text-muted classfontsmaller">
				<small>{UFunc.formatAngka(uTimeelapse)} ms</small>
			</span>
			</div>
			</CCardHeader>
			
			<CCardBody className="px-0">{contentLaporan()}</CCardBody>

			{(uJmlData > uMaxData) && (
				<CCardFooter>
				<MyPagination 
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i)=>setPageActive(i)}
					align="start"/>
				</CCardFooter>
			)}
		</CCard>
		)}

		<MyDialogform
			options={{centered:true}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={uIsDlgformshow} 
			dialogHeader={uHeaderDlgform}
			toggle={hdlToggleDlgform}
			renderContent={contentDlgform()}/>

		<iframe id="ifmcontentstoprint" className="d-none"/>
		</>
	)//>
}	

export default Lapterapi